import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Shipment } from 'graphql-models';
import type BoxApiService from 'walden-fast/services/box-api';
import shipmentQuery from 'walden-fast/graphql/shipments/shipment.graphql';
import type UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenBoxDetailModel = Resolved<
  ReturnType<AppServicesWaldenBoxDetailRoute['model']>
>;

export default class AppServicesWaldenBoxDetailRoute extends Route {
  @service('box-api') declare boxApiService: BoxApiService;
  @service('user') declare userService: UserService;

  async model(params: { shipment_id: string }) {
    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_BOX,
    );

    if (!userCanAccessService) {
      return { shipment: null };
    }

    const { shipmentById } = await this.boxApiService.query<{
      shipmentById: Shipment;
    }>({
      query: shipmentQuery,
      variables: { id: params.shipment_id },
    });

    if (!shipmentById) {
      throw new Error('Shipment not found');
    }

    return { shipment: shipmentById };
  }
}
